function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Arrow - down");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-1687.000000, -47.000000)"
}, React.createElement("g", {
  id: "Header---1820",
  transform: "translate(272.000000, 0.000000)"
}, React.createElement("g", {
  id: "right",
  transform: "translate(1076.000000, 30.000000)"
}, React.createElement("g", {
  id: "profile",
  transform: "translate(182.000000, 4.000000)"
}, React.createElement("g", {
  id: "Icons/Arrow---down",
  transform: "translate(154.000000, 8.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("g", {
  id: "Icons/Arrow---dropdown",
  strokeWidth: 1,
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  fill: "#1E1F20"
}, React.createElement("g", {
  transform: "translate(3.000000, 5.000000)",
  id: "Path"
}, React.createElement("path", {
  d: "M4.9999834,6 C4.82076305,6 4.64156483,5.92797172 4.50492535,5.784218 L0.205141796,1.25831682 C-0.0683805987,0.970413351 -0.0683805987,0.503627233 0.205141796,0.215840243 C0.478553534,-0.0719467475 0.921934686,-0.0719467475 1.19547921,0.215840243 L4.9999834,4.22060796 L8.80450972,0.215980013 C9.07803212,-0.0718069773 9.52136901,-0.0718069773 9.79475861,0.215980013 C10.0684138,0.503767003 10.0684138,0.970553121 9.79475861,1.25845659 L5.49504145,5.78435777 C5.35833558,5.92813479 5.17913736,6 4.9999834,6 Z"
})))))))));

var SvgDownarrow = function SvgDownarrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 10 6",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downarrow.47455866.svg";
export { ForwardRef as ReactComponent };